import { render, staticRenderFns } from "./toPayFeedbackList.vue?vue&type=template&id=0ddb0bc9&scoped=true"
import script from "./toPayFeedbackList.vue?vue&type=script&lang=js"
export * from "./toPayFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./toPayFeedbackList.vue?vue&type=style&index=0&id=0ddb0bc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddb0bc9",
  null
  
)

export default component.exports